/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VaultSecretRequest } from '../models/VaultSecretRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VaultSecretsService {
    /**
     * Add Secret To Vault
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static addSecretToVaultVaultV1VaultAddSecretPost(
        requestBody: VaultSecretRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/vault/v1/vault/add-secret',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
